export const AuditLogsConfig = {
  api: {
    index: '/dashboard/crud-logs/',
    loggedModels: '/dashboard/crud-logs/logged-models/',
  },
  events: {},
}
